import {useSelector} from "react-redux";

import AppreciationTabInputText from "../../component/appreciation/AppreciationTabInputText";
import MissingDataIndicator from "../../component/MissingDataIndicator";
import {selectPersistenceInitialized} from "../../redux/persistenceSlice";
import {selectLoading, selectRealAssetValueAvailable, selectRealAssetValueData} from "../../redux/valueIndicationSlice";
import PersistenceFinalMessage from "../object/PersistenceFinalMessage";
import SnapshotMessage from "../object/SnapshotMessage";
import IndicationTable from "./IndicationTable";

/** @type {Object<string, AppreciationKeyObj>} */
const RAV_APPRECIATIONS = {
    herstellungskosten: {page: "value", tab: "real_asset_value", section: "herstellungskosten"},
    zeitwert: {page: "value", tab: "real_asset_value", section: "zeitwert"},
};

export default function TabRealAssetValueIndication() {
    const realAssetValueData = useSelector(selectRealAssetValueData);
    const realAssetValueAvailable = useSelector(selectRealAssetValueAvailable);
    const loading = useSelector(selectLoading);
    const persistenceInitialized = useSelector(selectPersistenceInitialized);

    return (
        <>
            <MissingDataIndicator dataAvailable={realAssetValueAvailable || loading || !persistenceInitialized} />
            <PersistenceFinalMessage />
            <SnapshotMessage />
            <AppreciationTabInputText page="value" tab="real_asset_value" />
            <IndicationTable
                endpoint="REAL_ASSET_VALUE"
                indicationDetails={realAssetValueData}
                appreciations={RAV_APPRECIATIONS}
            />
        </>
    );
}
